<template>
	<v-container>
		<v-card v-for="(dog, index) in dogs" :key="index" class="pa-2 ma-2">
			<v-row>
				<v-col class="col-12"><h1>{{ dog.animal.name }}</h1></v-col>
				<v-col class="col-md-4 col-sm-4 col-12"><v-img :src="dog.animal.url" :key="index" width="150"></v-img></v-col>
				<v-col class="col-md-8 col-sm-8 col-12">
					<b>Sir:</b> 			{{ dog['animal']['father'] }}	<br>
					<b>х Dam:</b>				{{ dog['animal']['mother'] }}	<br>
					<b>Дата рождения:</b> 	{{ dog['animal']['birthday'] }}	<br>
					<b>Окрас: </b> 			{{ dog['animal']['color'] }}	<br>
					<b>Цвет глаз:</b> 		{{ dog['animal']['eye_color'] }}<br>
					<b>Вес:</b> 			{{ dog['animal']['weight'] }}	<br>
					<b>Рост:</b> 			{{ dog['animal']['growth'] }}	<br>
					<b>Прикус:</b>  		{{ dog['animal']['bite'] }}		<br>
					<b>HD (тест на дисплазию ТБС):</b>  {{ dog['animal']['test_hd_left'] }} / {{ dog['animal']['test_hd_right'] }}<br>
					<b>ED (тест на дисплазию ЛС):</b>   {{ dog['animal']['test_ed_left'] }} / {{ dog['animal']['test_ed_right'] }} <br>
					<b>Тест &lt;Мерль&gt; :</b> {{ dog['animal']['test_merle'] }} <br>
					<b>Тест BAER:</b> {{ dog['animal']['test_baer'] }} <br>
					<b>Проверка зрения:</b> {{ dog['animal']['test_eyeight_check'] }} <br>
				</v-col>
			</v-row>
		</v-card>
	</v-container>
</template>


<script>
import axios from 'axios'
//import VueAxios from 'vue-axios'

export default {
	name: "Dogs",
	data () {
		return {
			dogs: null,
		}
	},
	computed: {
		sex() {	return this.$route.params.sex },
	},
	watch: {
		sex(){ this.getDogList() }
	},
	beforeMount(){
		this.getDogList()
	},
	methods: {
		getDogList() {
			//var vm = this
			var url = 'http://catahoulakennel.ru/api/v1/pedigree/list?sex='+this.sex
			axios.get(url)
			.then(response => {this.dogs= response['data']})
		}
	}

}

</script>

